<template>
  <div class="appBody  bg-grey-light">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <van-nav-bar class="header-exam">
      <template #title>
        <div class="color-33 font-13 w-100 van-ellipsis">{{resultObj.title}}</div>
      </template>
    </van-nav-bar>
    <div class="mt-28 d-flex justify-content-center position-relative pass">
      <van-image class="pass-img" v-if="isPass"
                 src="/static/img/session/pass.png"/>
      <van-image class="pass-img" v-else
                 src="/static/img/session/again.png"/>
      <p v-if="isPass" class="pass-txt mb-0 font-13 line-16 text-white position-absolute van-ellipsis"
      >{{userInfo.name}}，恭喜你通过考试！</p>
      <p v-else class="pass-txt mb-0 font-13 line-16 text-white position-absolute van-ellipsis">
        {{userInfo.name}}，很遗憾没通过考试！</p>
      <div class="pass-score text-primary font-18 position-absolute">
        {{userLastExam.score|getDian}}分
      </div>
    </div>
    <div @click="repalyFunc" class="again-div cursor-pointer mt-3 d-flex align-items-center justify-content-center"
         v-if="!resultObj.submitTimes || resultObj.submitTimes-examTimes > 0">
      <van-icon class="mr-2 replay-icon text-primary font-weight-bold" name="replay"/>
      <div class="d-flex text-primary font-12 color-66">
        <span class="text-primary font-weight-bold">再考一次</span>
        <div v-if="!isPass && resultObj.submitTimes > 0">
          您还有<span class="text-primary font-weight-bold">{{ resultObj.submitTimes - examTimes }}</span>
          次考试机会
        </div>
      </div>
    </div>
    <van-row type="flex" class="bg-white mx-3 mt-4 flex-column radius-all">
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/defen.png"
        />
        得分
        <span class="ml-auto">{{userLastExam.score|getDian}}分</span>
      </van-col>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/defenlv.png"
        />
        得分率
        <span class="ml-auto">{{(scoreRate?scoreRate:0.00)}}%</span>
      </van-col>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/manfen.png"
        />
        满分
        <span class="ml-auto">{{totalScore|getDian}}分</span>
      </van-col>
      <van-col class="result-col d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/history.png"
        />
        历史最高分
        <span class="ml-auto">{{maxScore|getDian}}分</span>
      </van-col>
      <van-col class="result-col border-bottom-0 d-flex align-items-center color-33 font-14">
        <van-image class="mr-10 icon-result"
                   src="/static/img/session/time_used.png"
        />
        用时
        <span class="ml-auto">{{usedTimeStr}}</span>
      </van-col>
    </van-row>

    <div class="answer-btn">
      <van-button class="w-100 font-13" round block type="info"
                  @click="goAnswerPage">
        <div class="flex-auto">{{resultBtnText}}</div>
        <van-image class="icon-answer"
                   :src="resultBtnImageUrl"
        />
      </van-button>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Button, NavBar} from 'vant';
  import {Image as VanImage} from 'vant';
  import {Icon} from 'vant';
  import {Col, Row} from 'vant';
  import Cookies from "js-cookie";

  Vue.use(Icon);
  Vue.use(NavBar);
  Vue.use(Button);
  Vue.use(VanImage);
  Vue.use(Col);
  Vue.use(Row);
  export default {
    name: "examResult",
    data() {
      return {
        isPass: false,
        examId: '',
        uExamId: '',
        resultBtnText: '',
        resultBtnImageUrl: '',
        resultObj: {},
        userLastExam: {},
        maxScore: 0,
        totalScore: 0,
        serverCurrentTime: 0,
        scoreRate: '0.00',
        examTimes: 0,
        userInfo: {},
        usedTimeStr: ''
      }
    },
    props: [
      'userExamId',
      'examResult'
    ],
    created() {
      if (this.userExamId) {
        this.uExamId = this.userExamId;
        console.log(this.uExamId)
      }
      if (this.examResult) {
        this.resultObj = this.examResult;
      }
    },
    mounted() {
      this.examId = this.$route.params['id'];
      let names = window.location.hostname.split(".");
      if (names.length > 2) {
        names[0] = "";
      }
      this.domain = names.join(".");
      if (Cookies.get('anqiu_education_token') && Cookies.get('u_info')) {
        this.userInfo = JSON.parse(Cookies.get('u_info'));
      } else {
        this.userInfo = {};
        this.$store.commit('MOVE_TOKEN', {name: {key: 'u_info'}, options: {domain: this.domain}});
      }

      if (this.resultObj && this.resultObj.id) {
        this.getExamResult();
      } else {
        this.loadData();
      }

    },
    methods: {
      loadData() {
        this.$store.dispatch('getSessionExamForLearnerUrl', {id: this.examId}).then((res) => {
          if (res) {
            this.resultObj = res;
            this.getExamResult();
          }
        })
      },
      repalyFunc() {
        this.$router.push({name: 'examIndex', params: {id: this.examId}});
      },
      getExamResult() {

        if (this.resultObj.userSession && this.resultObj.userSession.userExams && this.resultObj.userSession.userExams.length > 0) {

          if (this.resultObj.userSession && this.resultObj.userSession.userExams) {
            this.examTimes = this.resultObj.userSession.userExams.length
          }
          //最后一次考试成绩
          //历史最高分
          for (let model of this.resultObj.userSession.userExams) {

            if (model.score > this.maxScore) {
              this.maxScore = model.score;
            }
            //从考试页面过来的成绩
            if (this.uExamId && this.uExamId === model.id) {
              this.userLastExam = model;
              //为了遍历历史最高分不能break！！！！！！！！！！！！！
            } else if(!this.uExamId) {
              // 最近的一条为最后一次考试
              this.userLastExam = this.resultObj.userSession.userExams[0];
            }
            // //最后一次交卷的成绩
            // if (model.finished) {
            //   this.userLastExam = model;
            // }
          }
          if (this.userLastExam && this.uExamId === '') {
            this.uExamId = this.userLastExam.id;
          }
          if (this.userLastExam && this.userLastExam.score>=0 && this.resultObj.passmark>=0) {
            if (this.userLastExam.score >= this.resultObj.passmark) {
              this.isPass = true;
            } else {
              this.isPass = false;
            }
          }

          let showType = this.resultObj.showType;
          if (showType === 'nil') {
            this.resultBtnText = '查看我的答案';
            this.resultBtnImageUrl = '/static/img/session/wode.png';
          } else if (showType === 'correctAnswer') {
            this.resultBtnText = '查看正确答案';
            this.resultBtnImageUrl = '/static/img/session/zhengque.png';
          } else if (showType === 'rightOrWrong') {
            this.resultBtnText = '查看答题情况';
            this.resultBtnImageUrl = '/static/img/session/dati.png';
          }
          //满分
          if (this.resultObj.statInfo && this.resultObj.statInfo.totalScore >= 0) {
            this.totalScore = this.resultObj.statInfo.totalScore;
          } else {
            this.totalScore = 0;
          }
          //得分率
          if (this.totalScore > 0) {
            this.scoreRate = ((this.userLastExam.score / this.totalScore) * 100).toFixed(2);
          }
          this.getTime();
        }
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.resultObj;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
      onClickLeft() {
        location.reload();
      },
      getTimeStr(value) {
        let time = '';
        let leftTime = value;
        let func = function checTime(i) {
          return i < 10 ? "0" + i : i + "";
        };

        let h = parseInt(leftTime / (1000 * 60 * 60) % 24);
        let m = parseInt(leftTime / (1000 * 60) % 60);
        let s = parseInt(leftTime / 1000 % 60);

        let hours = func(h);
        let minutes = func(m);
        let seconds = func(s);

        if (hours > 0) {
          time = hours + ':' + minutes + ':' + seconds;
        } else if (minutes > 0) {
          time = '00:' + minutes + ':' + seconds;
        } else if (seconds > 0) {
          time = '00:' + '00:' + seconds;
        }
        return time;
      },
      getTime() {
        let count = 0;
        let startTime = 0;
        let finishedTime = 0;
        if (this.userLastExam && this.userLastExam.createdTime) {
          startTime = this.userLastExam.createdTime;
        }

        if (this.userLastExam && this.userLastExam.finishedTime) {
          finishedTime = this.userLastExam.finishedTime;
        }
        count = finishedTime - startTime;
        this.usedTimeStr = this.getTimeStr(count);
      },
      goAnswerPage() {
        this.$router.push({name: 'examAnswer', query: {id: this.examId, userExamId: this.uExamId}});
      },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .result-col {
    margin: pxTorem(0px) pxTorem(16px) pxTorem(0px) pxTorem(16px);
    border-bottom: pxTorem(1px) solid #eeeeee;
    height: pxTorem(48px);
  }

  .replay-icon {
    width: pxTorem(12px);
  }

  .icon-answer {
    height: pxTorem(13px);
    width: pxTorem(13px);
  }

  .pass-img {
    width: pxTorem(231px);
    height: pxTorem(118px);
  }

  .pass {
    width: pxTorem(231px);
    height: pxTorem(118px);
    left: 50%;
    margin-left: pxTorem(-115px);
  }

  .pass-txt {
    width: 100%;
    height: pxTorem(76px);
    top: pxTorem(58px);
    left: 0;
    text-align: center;
  }

  .flex-auto {
    flex: auto;
  }

  .pass-score {
    right: pxTorem(4px);

    margin-top: pxTorem(30px);
  }

  .icon-result {
    width: pxTorem(15px);
    height: pxTorem(15px);
  }

  .radius-all {
    border-radius: pxTorem(4px);
  }

  .answer-btn {
    margin: pxTorem(40px) pxTorem(56px) pxTorem(0px) pxTorem(56px);
    padding-bottom: pxTorem(40px);

    .van-button__text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .van-button {
      height: pxTorem(36px);
    }
  }
</style>
